 <!-- Preview Section (Fixed Height Always) -->
<div  style="margin-top:15px;"  [style.min-height]="previewMinHeight">

  <table class="table" *ngIf="ImagePath != ''">
    <tbody>
      <tr>
        <!-- IMAGE PREVIEW -->
        <td *ngIf="['png','jpg','jpeg','gif'].includes(extension)"
            style="text-align:left">
          <img 
            [src]="ImagePath"
             [style.height]="imageHeight"
            style="width:auto;cursor:pointer"
            (click)="openFile()"
          />
        </td>

        <!-- DOCUMENT PREVIEW -->
        <td *ngIf="!['png','jpg','jpeg','gif'].includes(extension)"
            style="text-align:left; vertical-align:middle;">
          <strong>
            <a href="javascript:void(0)"
               (click)="openFile()">
              {{ ImageName }}
            </a>
          </strong>
        </td>

      </tr>
    </tbody>
  </table>

</div>


<!-- Upload & Remove Buttons -->
<div class="col-sm-12 box-row" 
     *ngIf="category != 'inventoryequipment_detail'"
     style="display:flex; align-items:center; gap:10px;"> 

  <input type="file"
         class="FileInput hidden"
         id="{{uploadID}}"
         ng2FileSelect
         [uploader]="uploader" />

  <button (click)="UploadFiles()"
          [disabled]="isUploadDisabled"
          class="btn btn-success"
          type="button">
    <span class="glyphicon glyphicon-arrow-up"></span> Upload
  </button>

  <button *ngIf="ImagePath"
          type="button"
          [disabled]="isUploadDisabled"
          class="btn btn-danger"
          (click)="reset()">
    <span class="glyphicon glyphicon-trash"></span> Remove
  </button>

</div>